import { atom } from "recoil";

import { PaymentProvider, PrescriptionOrderCalculationModel } from "graphql/generated";

import keys from "./constants";

export const isSameAsBillingAddressState = atom<any>({
  key: keys.IS_SAME_AS_BILLING_ADDRESS_STATE,
  default: true
});

export const isWarningRenewModalOpenedState = atom<boolean>({
  key: keys.IS_WARNING_RENEW_MODAL_OPENED_STATE,
  default: false
});

export const isRetryModalOpenedState = atom<boolean>({
  key: keys.IS_RETRY_MODAL_OPENED_STATE,
  default: false
});

export const modalCancelingItemState = atom<any>({
  key: keys.MODAL_CANCELING_ITEM_STATE,
  default: false
});

export const suggestionItemsState = atom<any[]>({
  key: keys.SUGGESTION_ITEMS_STATE,
  default: null
});

export const isPaymentSuccessState = atom<boolean>({
  key: keys.IS_PAYMENT_SUCCESS_STATE,
  default: false
});

export const isPromotionDisabledState = atom<boolean>({
  key: keys.IS_PROMOTION_DISABLED_STATE,
  default: false
});

export const isPromotionAppliedState = atom<boolean>({
  key: keys.IS_PROMOTION_APPLIED_STATE,
  default: false
});

export const isCheckoutButtonLoadingState = atom<boolean>({
  key: keys.IS_CHECKOUT_BUTTON_LOADING_STATE,
  default: false
});

export const areDisabledCheckoutButtonsState = atom<boolean>({
  key: keys.ARE_DISABLED_CHECKOUT_BUTTONS_STATE,
  default: false
});

export const guestItemState = atom<any>({
  key: keys.GUEST_ITEM_STATE,
  default: null
});

export const isCancelModalRemovingState = atom<boolean>({
  key: keys.IS_CANCEL_MODAL_REMOVING_STATE,
  default: false
});

export const guestCheckoutDataState = atom<{
  productId: string;
  priceId: string;
  productData: any;
}>({
  key: keys.GUEST_CHECKOUT_DATA_STATE,
  default: null
});

export const checkoutDataState = atom<{
  paymentIntent: string;
  checkoutData: any;
  giveawayData?: any;
  paymentProvider?: PaymentProvider;
  guestThankYouData?: any;
  hasFutureUsage?: boolean;
}>({
  key: keys.PAYMENT_INTENT_STATE,
  default: {
    paymentIntent: "",
    checkoutData: null,
    giveawayData: null,
    guestThankYouData: null,
    hasFutureUsage: true
  }
});

export const isFromPaymentPageState = atom<boolean>({
  key: keys.IS_FROM_PAYMENT_PAGE_STATE,
  default: false
});

export const prescriptionCheckoutDataState = atom<{
  paymentIntent: string;
  checkoutData: any;
  calculation: PrescriptionOrderCalculationModel;
}>({
  key: keys.PRESCRIPTION__CHECKOUT_DATA_STATE,
  default: {
    paymentIntent: "",
    checkoutData: null,
    calculation: null
  }
});
